<template>
  <v-app>
    <div v-if="is_superadmin">
      <v-toolbar dark dense flat class="page_toolbar admin_menu_toolbar">
        <v-toolbar-title>
          <v-icon left small>fa-cogs</v-icon>Admin
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn small text to="/app/admin/clinics">
            <v-icon left>business</v-icon>Clinics
          </v-btn>
          <v-btn small text to="/app/admin/signup_pages">
            <v-icon left small>mdi-television-guide</v-icon>Signups
          </v-btn>
          <v-btn small text to="/app/admin/revisions">
            <v-icon left>fa-database</v-icon>Revisions
          </v-btn>
          <v-btn small text to="/app/admin/users">
            <v-icon left>account_circle</v-icon>Users
          </v-btn>
          <v-btn small text to="/app/admin/charges">
            <v-icon left>attach_money</v-icon>Charges
          </v-btn>
          <v-btn small text to="/app/admin/monthly">
            <v-icon left>assessment</v-icon>KPI
          </v-btn>
          <v-btn small text to="/app/admin/emails">
            <v-icon left>email</v-icon>Emails
          </v-btn>
          <v-btn small text to="/app/admin/misc">
            <v-icon left>build</v-icon>Misc
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <AdminSignupPages />
    </div>
    <PermissionDenied v-else />
  </v-app>
</template>

<script>
import AdminSignupPages from "../../shared/components/admin/AdminSignupPages";
import PermissionDenied from "../../shared/components/PermissionDenied";

export default {
  components: {
    AdminSignupPages,
    PermissionDenied,
  },
  data() {
    return {
      current_user: this.$root.$children[0].current_user,
    };
  },
  computed: {
    is_superadmin() {
      return !!(
        this.current_user &&
        this.current_user.is_admin &&
        Array.isArray(this.current_user.admin_roles) &&
        this.current_user.admin_roles.includes("superadmin")
      );
    },
  },
};
</script>
